import "core-js/modules/es.array.reverse.js";
var _class;
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { action, computed, makeObservable, override, runInAction } from "mobx";
import isDefined from "../../../Core/isDefined";
import TerriaError from "../../../Core/TerriaError";
import AutoRefreshingMixin from "../../../ModelMixins/AutoRefreshingMixin";
import TableMixin from "../../../ModelMixins/TableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import Csv from "../../../Table/Csv";
import TableAutomaticStylesStratum from "../../../Table/TableAutomaticStylesStratum";
import CsvCatalogItemTraits from "../../../Traits/TraitsClasses/CsvCatalogItemTraits";
import CommonStrata from "../../Definition/CommonStrata";
import CreateModel from "../../Definition/CreateModel";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";

// Types of CSVs:
// - Points - Latitude and longitude columns or address
// - Regions - Region column
// - Chart - No spatial reference at all
// - Other geometry - e.g. a WKT column

// Types of time varying:
// - ID+time column -> point moves, region changes (continuously?) over time
// - points, no ID, time -> "blips" with a duration (perhaps provided by another column)
//
let CsvCatalogItem = (_class = class CsvCatalogItem extends AutoRefreshingMixin(TableMixin(UrlMixin(CreateModel(CsvCatalogItemTraits)))) {
  static get type() {
    return "csv";
  }
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    makeObservable(this);
    this.strata.set(TableAutomaticStylesStratum.stratumName, new TableAutomaticStylesStratum(this));
  }
  get type() {
    return CsvCatalogItem.type;
  }
  setFileInput(file) {
    this.setTrait(CommonStrata.user, "url", URL.createObjectURL(file) + "#" + file.name);
  }
  get hasLocalData() {
    var _this$url$startsWith, _this$url;
    return (_this$url$startsWith = (_this$url = this.url) === null || _this$url === void 0 ? void 0 : _this$url.startsWith("blob:")) !== null && _this$url$startsWith !== void 0 ? _this$url$startsWith : false;
  }
  get _canExportData() {
    return isDefined(this.csvString) || isDefined(this.url);
  }
  get cacheDuration() {
    return super.cacheDuration || "1d";
  }
  async _exportData() {
    if (isDefined(this.csvString)) {
      return {
        name: this.name || this.uniqueId,
        file: new Blob([this.csvString])
      };
    }
    if (isDefined(this.url)) {
      return this.url;
    }
    throw new TerriaError({
      sender: this,
      message: "No data available to download."
    });
  }

  /*
   * The polling URL to use for refreshing data.
   */
  get refreshUrl() {
    return this.polling.url || this.url;
  }

  /*
   * Called by AutoRefreshingMixin to get the polling interval
   */
  get refreshInterval() {
    if (this.refreshUrl) {
      return this.polling.seconds;
    }
  }

  /*
   * Hook called by AutoRefreshingMixin to refresh data.
   *
   * The refresh happens only if a `refreshUrl` is defined.
   * If `shouldReplaceData` is true, then the new data replaces current data,
   * otherwise new data is appended to current data.
   */
  refreshData() {
    if (!this.refreshUrl) {
      return;
    }
    Csv.parseUrl(proxyCatalogItemUrl(this, this.refreshUrl), true, this.ignoreRowsStartingWithComment).then(dataColumnMajor => {
      runInAction(() => {
        if (this.polling.shouldReplaceData) {
          this.dataColumnMajor = dataColumnMajor;
        } else {
          this.append(dataColumnMajor);
        }
      });
    });
  }
  forceLoadTableData() {
    if (this.csvString !== undefined) {
      return Csv.parseString(this.csvString, true, this.ignoreRowsStartingWithComment);
    } else if (this.url !== undefined) {
      return Csv.parseUrl(proxyCatalogItemUrl(this, this.url), true, this.ignoreRowsStartingWithComment);
    } else {
      return Promise.reject(new TerriaError({
        sender: this,
        title: i18next.t("models.csv.unableToLoadItemTitle"),
        message: i18next.t("models.csv.unableToLoadItemMessage")
      }));
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "setFileInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFileInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLocalData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasLocalData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_canExportData", [override], Object.getOwnPropertyDescriptor(_class.prototype, "_canExportData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cacheDuration", [override], Object.getOwnPropertyDescriptor(_class.prototype, "cacheDuration"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "refreshUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshInterval", [override], Object.getOwnPropertyDescriptor(_class.prototype, "refreshInterval"), _class.prototype), _class);
export { CsvCatalogItem as default };
StratumOrder.addLoadStratum(TableAutomaticStylesStratum.stratumName);